import React from 'react';
import catLogo from '../../images/cat-logo.png';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <defs>
      <clipPath id="hex-clip">
        <polygon points="50,8 13,29 13,71 50,92 87,71 87,29" />
      </clipPath>
    </defs>
    <g>
      <g id="B">
        <image
          href={catLogo}
          x="13"
          y="8"
          width="74"
          height="84"
          clipPath="url(#hex-clip)"
          preserveAspectRatio="xMidYMid slice"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50,5 L 11,27 L 11,72 L 50,95 L 89,73 L 89,28 Z"
      />
    </g>
  </svg>
);

export default IconLoader;
